<template>
  <div class="container">
    <Navbar />
    <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{ name: 'MyRestaurants' }">
            <a>My Restaurant(s)</a>
          </router-link>
        </li>
        <li
          v-if="this.isRestExists"
          class="breadcrumb-item active"
          aria-current="page"
        >
          <router-link
            tag="li"
            :to="{
              name: 'CurrentRestaurantMenu',
              params: { id: restNum, restId: restId },
            }"
          >
            {{ this.userName }}
          </router-link>
        </li>
        <li
          v-if="this.isRestExists"
          class="breadcrumb-item active"
          aria-current="page"
        >
          Remove Modifier
        </li>
      </ol>
    </nav>
    <div v-if="this.isRestExists" class="add-new-restaurant-page">
      <p>
        {{ userName }} <faIcons :icon="['fas', 'dot-circle']" />
        {{ userAddress }}
      </p>
      <!-- Add new Modifier -->
      <form method="post" action="#" enctype="multipart/form-data">
        <div v-if="this.catExists" class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div
              class="form-floating"
              :class="{ 'form-data-error': catNameErr }"
            >
              <input
                type="text"
                id="userNameInput"
                placeholder="Modifier Name"
                class="form-control w300"
                @keyup="validateCategoryName($event)"
                @change="validateCategoryName($event)"
                v-model.trim="catName"
                disabled
              />
              <label for="userNameInput"
                ><faIcons :icon="['fas', 'sitemap']" /> Modifier Name</label
              >
              <span class="error-feedback" v-if="catNameErr">
                {{ catNameMsg }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="this.catExists"
          class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-2"
        >
          <div id="deleteCuurentRestaurant" class="form-text">
            Deleting this modifier will affect all items that is currently using this modifier. This action cannot be undone.
          </div>
          <button
            class="btn btn-outline-danger"
            @click.prevent="RemoveCurrentMenuModifier()"
            v-if="signUpBtn"
          >
            <faIcons :icon="['fas', 'trash']" /> Remove This Modifier
          </button>
        </div>
        <div
          v-if="this.catExists"
          class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3"
        >
          <div class="alert alert-success" role="alert" v-if="resultSuccess">
            {{ resultSuccessMsg }}
          </div>
          <div class="alert alert-danger" role="alert" v-if="resultErr">
            {{ resultErrMsg }}
          </div>
        </div>
        <div v-else class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <div class="alert alert-warning" role="alert">
            This Modifier is no longer existing
          </div>
          <router-link
            class="btn btn-outline-primary"
            :to="{
              name: 'CurrentRestaurantMenu',
              params: { id: restNum, restId: restId },
            }"
          >
            <faIcons :icon="['fas', 'undo']" /> Go back
          </router-link>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <router-link
            class="btn btn-outline-primary"
            :to="{
              name: 'CurrentRestaurantMenu',
              params: { id: restNum, restId: restId },
            }"
          >
            <faIcons :icon="['fas', 'undo']" /> Never mind, go back!
          </router-link>
        </div>
      </form>
    </div>
    <div v-else>
      <!-- Show error if no restaurant matches this Criteria -->
      <div class="alert alert-dark" role="alert">
        <p>
          No restaurant found. Make sure you click in the right restaurant name.
        </p>
      </div>
      <router-link tag="li" :to="{ name: 'MyRestaurants' }">
        <a>Go back to my restaurant(s)</a>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";
import Navbar from "@/components/Header/Navbar.vue";
export default {
  name: "RemoveMenuModifier",
  components: {
    Navbar,
  },
  data() {
    return {
      user: {
        uId: "",
        userId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
      //cat
      catName: "",
      catNameErr: false,
      catNameMsg: "",
      iscatNameValidated: false,
      //Restaurant Info from URL
      restId: this.$route.params.restId,
      restNum: this.$route.params.id,
      //cat id
      catId: this.$route.params.modifierId,
      //address
      userAddress: "",
      userAddressErr: false,
      userAddressMsg: "",
      isuserAddressValidated: false,
      //phone
      userPhone: "",
      userPhoneErr: false,
      userPhoneMsg: "",
      isuserPhoneValidated: false,
      //name
      userName: "",
      userNameErr: false,
      userNameMsg: "",
      isuserNameValidated: false,
      //does Modifier exits:
      catExists: false,
      resultSuccess: false,
      resultSuccessMsg: "",
      resultErr: false,
      resultErrMsg: "",
      image: "",
      is_DB_Connected: "",
      db_connection_msg: "",
      // apiMainUrl: "http://localhost/php/login-system-php-vue-2021/myData.php",
      apiMainUrl: this.$store.getters.MainUrl, //call global variable
      signUpBtn: true,
      isRestExists: false,
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    let currentRestaurants = localStorage.getItem("current_restaurants_data");
    let currentRestaurant = JSON.parse(currentRestaurants).filter(
      (restInfo) =>
        restInfo.id == this.restNum && restInfo.rest_id == this.restId
    );
    let currentModifiers = localStorage.getItem(
      "current_user_menu_modifiers_data"
    );
    let currentModifier = JSON.parse(currentModifiers).filter(
      (catInfo) =>
        catInfo.group_name_rand_id == this.catId &&
        catInfo.rest_id == this.restId
    );
    if (user && currentRestaurants) {
      //set rest info
      if (currentRestaurant.length > 0 && currentModifier.length > 0) {
        console.table(currentRestaurant);
        console.log(this.catId);
        console.log(this.restId);
        if (currentModifier.length > 0) {
          console.log("Modifier Name is " + currentModifier[0].group_name);
          this.catName = currentModifier[0].group_name;
          this.catExists = true;
        } else {
          this.catExists = false;
        }
        this.isRestExists = true;
        //set Cat name to old name:
        this.userPhone = currentRestaurant[0].rest_phone;
        this.userName = currentRestaurant[0].rest_name;
        this.userAddress = currentRestaurant[0].rest_address;
        //get users info
        this.user.uId = JSON.parse(user).id;
        this.user.userId = JSON.parse(user).user_id;
        this.user.uName = JSON.parse(user).name;
        this.user.uEmail = JSON.parse(user).email;
        this.user.uPassword = JSON.parse(user).password;
        this.user.uMemberSince = JSON.parse(user).member_since;
        this.user.uAddress = JSON.parse(user).full_address;
        this.user.uPhone = JSON.parse(user).phone_number;
        this.user.uRole = JSON.parse(user).role;
        //if role isn't manager or admin, redirect
        if (currentRestaurant[0].active == 0) {
          //if restaurant isn't active
          this.$router.push({ name: "MyRestaurants" });
        } else if (
          JSON.parse(user).role !== "mngr" &&
          JSON.parse(user).role !== "admn"
        ) {
          this.$router.push({ name: "Login" });
        }
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    ...mapState([
      "__RestaurantId",
      "__RestaurantEmail",
      "__RestaurantRole",
      "__RestaurantName",
      "__MainUrl",
    ]),
    ...mapGetters(["MainUrl"]),
  },
  methods: {
    ...mapMutations(["setRestaurantInfo"]),
    //validate Restaurant Name
    validateCategoryName(e) {
      let val = e.target.value;
      this.validateCategoryNameInput(val);
    },
    validateCategoryNameInput(val) {
      if (val == "") {
        this.catNameErr = true;
        this.iscatNameValidated = false;
        this.catNameMsg = "Must Enter Modifier Name ..";
      } else {
        this.catNameErr = false;
        this.iscatNameValidated = true;
        this.catNameMsg = "";
      }
    },
    async RemoveCurrentMenuModifier() {
      this.validateCategoryNameInput(this.catName);
      if (this.iscatNameValidated) {
        this.signUpBtn = false;
        //show Result
        let fd = new FormData();
        fd.append("userId", this.user.userId);
        fd.append("catName", this.catName);
        fd.append("restId", this.restId);
        fd.append("catId", this.catId);
        // fd.append("restNum", this.restNum);
        let rst = await axios.post(
          this.apiMainUrl + `?action=RemoveCurrentMenuModifier`,
          fd
        );
        console.log(rst);
        const resultData = rst.data;
        if (rst.status == 200) {
          if (resultData.error) {
            console.warn("Connection Error Happened on Adding New Modifier");
            this.resultErrMsg = resultData.message;
            this.resultErr = true;
            this.resultSuccessMsg = "";
            this.resultSuccess = false;
            this.signUpBtn = true;
          } else {
            this.signUpBtn = false;
            console.log("New Modifier has been deleted..");
            //if everything is okay
            this.resultErrMsg = "";
            this.resultErr = false;
            this.resultSuccess = true;
            //set restaurant to local host: current_restaurants_data
            // localStorage.setItem(
            //   "current_restaurants_data",
            //   JSON.stringify(resultData.current_restaurants_data)
            // );
            //redirect only if customer
            //add new Modifier to current_user_menu_modifiers_data
            //now get current categories, then push a new object to it and last set a new localhost
            let currentModifiers = JSON.parse(
              localStorage.getItem("current_user_menu_modifiers_data")
            );
            //this is an array of object [{}], so only get the object of it [0]
            // var newMenuCategory =
            //   resultData.current_restaurants_menu_category_data[0];
            // currentModifiers.push(newMenuCategory); //add this object to newMenuCategory array
            let currentModifierId = this.catId;
            let newModifier = currentModifiers.filter(function (item) {
              console.log(item);
              return item.group_name_rand_id !== currentModifierId;
            });
            // for (let i = 0; i < currentModifiers.length; i++) {
            //   if (currentModifiers[i].cat_id === this.catId) {
            //     //remove this one from current Modifier data
            //     currentModifiers.splice(currentModifiers[i]-1, 1);
            //     // currentModifiers[i].cat_name = this.catName;
            //   }
            // }
            console.table(newModifier);
            localStorage.setItem(
              "current_user_menu_modifiers_data",
              JSON.stringify(newModifier)
            );
            //https://stackoverflow.com/questions/35963412/append-data-to-localstorage-object
            this.resultSuccessMsg = resultData.message;
            //redirect to current restaurant page
            setTimeout(() => {
              this.$router.push({
                name: "CurrentRestaurantMenu",
                params: { id: this.restNum, restId: this.restId },
              });
              console.log("Restaurant Name: " + this.userName);
            }, 2000);
          }
        }
      } else {
        this.signUpBtn = true;
        this.validateCategoryNameInput(this.catName);
        this.resultSuccessMsg = "";
        this.resultSuccess = false;

        this.resultErrMsg = "Must enter all required information";
        this.resultErr = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$navColor: #3f51b6;
nav a {
  text-decoration: none;
  color: $navColor;
  font-weight: bold;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
